import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, FormControlLabel, FormGroup, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import { UserAdminEmailNotificationsDto } from '../../../../dtos/Users/UserAdminEmailNotificationsDto';
import Section from '../../../Common/Section';

export default function UserEmailNotificationSettings (props) {
    const {
        userAdminEmailNotification, setNewUserAdminEmailNotification, applyNotificationChangesRetroactively, setApplyNotificationChangesRetroactively,
    } = props;
    const { t } = useTranslation();

    const handleFieldChange = (field, value) => {
        const updatedSettings = { ...userAdminEmailNotification };
        updatedSettings[field] = value;
        setNewUserAdminEmailNotification(updatedSettings);
    };

    // Coerce a boolean-ish input to the 0/1 the DB expects.
    const toBit = (next) => (next ? 1 : 0);

    const notificationsEnabled = Boolean(userAdminEmailNotification.usEnableNotifications);

    const autoSubscribeOptions = [
        { field: 'usAutoSubscribe', labelKey: 'userEmailNotifications.autoSubscribeAll' },
        { field: 'usAutoSubscribeOwnTasks', labelKey: 'userEmailNotifications.autoSubscribeAssigned' },
        { field: 'usAutoSubscribeReportedTasks', labelKey: 'userEmailNotifications.autoSubscribeReported' },
        { field: 'usAutoSubscribeVerifierTasks', labelKey: 'userEmailNotifications.autoSubscribeVerifier' },
        { field: 'usAutoSubscribeAuditorTasks', labelKey: 'userEmailNotifications.autoSubscribeAuditor' },
    ];

    return (
        <Box sx={{ pt: 1 }}>
            <Section title={t('userEmailNotifications.section.general')}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={notificationsEnabled}
                            onChange={() => handleFieldChange('usEnableNotifications', toBit(!notificationsEnabled))}
                        />}
                        label={t('userEmailNotifications.enable')}
                    />
                </Grid>
            </Section>

            <Section title={t('userEmailNotifications.section.autoSubscribe')}>
                <Grid item xs={12}>
                    {!notificationsEnabled && (
                        <Alert severity="info" sx={{ mb: 1.5 }}>
                            {t('userEmailNotifications.help.disabled')}
                        </Alert>
                    )}
                    <FormGroup sx={{ opacity: notificationsEnabled ? 1 : 0.55 }}>
                        {autoSubscribeOptions.map(({ field, labelKey }) => (
                            <FormControlLabel
                                key={field}
                                control={<Checkbox
                                    disabled={!notificationsEnabled}
                                    checked={Boolean(userAdminEmailNotification[field])}
                                    onChange={() => handleFieldChange(field, toBit(!userAdminEmailNotification[field]))}
                                />}
                                label={t(labelKey)}
                            />
                        ))}
                    </FormGroup>
                </Grid>
            </Section>

            <Section title={t('userEmailNotifications.section.other')}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={applyNotificationChangesRetroactively}
                            onChange={() => setApplyNotificationChangesRetroactively(!applyNotificationChangesRetroactively)}
                        />}
                        label={t('userEmailNotifications.retroactive')}
                    />
                </Grid>
            </Section>
        </Box>
    );
}

UserEmailNotificationSettings.propTypes = {
    userAdminEmailNotification: PropTypes.objectOf(UserAdminEmailNotificationsDto),
    setNewUserAdminEmailNotification: PropTypes.func.isRequired,
    applyNotificationChangesRetroactively: PropTypes.bool.isRequired,
    setApplyNotificationChangesRetroactively: PropTypes.func.isRequired,
};
